// Strip pre-loaded city options from every Pods DFV inline JSON before React reads
// them on DOMContentLoaded. Without this, fieldItemData populates dropdowns on open,
// bypassing the territory filter. With it, dropdowns are empty until AJAX fires.
( function () {
	document
		.querySelectorAll( 'script.pods-dfv-field-data' )
		.forEach( function ( script ) {
			try {
				const data = JSON.parse( script.textContent );
				if ( data?.fieldConfig?.name?.endsWith( '_city' ) ) {
					// Keep only already-selected items so saved values display
					// correctly on edit, but strip everything else to force AJAX.
					data.fieldItemData = ( data.fieldItemData ?? [] ).filter(
						( item ) => item.selected === true
					);
					if ( data.fieldConfig ) {
						data.fieldConfig.data = {};
					}
					script.textContent = JSON.stringify( data );
				}
			} catch ( e ) {}
		} );
} )();

const PENINSULA_ID = 9;

function findWrapper( form, name ) {
	return form.querySelector(
		`.pods-form-ui-row-name-${ name.replace( /_/g, '-' ) }`
	);
}

// Controls visibility of territory/region/city/address fields in a location block.
// Pass locationField to gate sub-fields on a boolean toggle; omit it (person) to
// leave them always visible. regionField, cityField and addressField are all optional.
export function setupLocationVisibility(
	form,
	{ locationField, territoryField, regionField, cityField, addressField }
) {
	const locationWrapper = locationField
		? findWrapper( form, locationField )
		: null;
	const territoryWrapper = findWrapper( form, territoryField );
	const regionWrapper = regionField ? findWrapper( form, regionField ) : null;
	const cityWrapper = cityField ? findWrapper( form, cityField ) : null;
	const addressWrapper = addressField
		? findWrapper( form, addressField )
		: null;

	if ( ! territoryWrapper ) {
		return;
	}

	function applyVisibility() {
		const isLocationSet = locationWrapper
			? !! locationWrapper.querySelector(
					`input[name="pods_field_${ locationField }"]:checked`
			  )
			: true;

		const selectedIds = [
			...territoryWrapper.querySelectorAll(
				`input[type="hidden"][name^="pods_field_${ territoryField }"]`
			),
		].map( ( el ) => parseInt( el.value ) );

		const isPeninsula = selectedIds.includes( PENINSULA_ID );
		const hasNonPeninsula = selectedIds.some(
			( id ) => id !== PENINSULA_ID
		);

		territoryWrapper.style.display = isLocationSet ? '' : 'none';
		if ( regionWrapper ) {
			regionWrapper.style.display =
				isLocationSet && isPeninsula ? '' : 'none';
		}
		if ( cityWrapper ) {
			cityWrapper.style.display =
				isLocationSet && ( ! isPeninsula || hasNonPeninsula )
					? ''
					: 'none';
		}
		if ( addressWrapper ) {
			addressWrapper.style.display =
				isLocationSet && ( ! isPeninsula || hasNonPeninsula )
					? ''
					: 'none';
		}
	}

	applyVisibility();

	if ( locationWrapper ) {
		locationWrapper.addEventListener( 'change', applyVisibility );
	}

	new MutationObserver( applyVisibility ).observe( territoryWrapper, {
		childList: true,
		subtree: true,
	} );
}

// Intercept fetch() calls for Pods DFV city field AJAX and inject territory_filter as
// a URL query parameter. PHP reads it in the pods_field_pick_data_ajax_items filter.
if ( ! window._anacrm_city_filter_registered ) {
	window._anacrm_city_filter_registered = true;

	const originalFetch = window.fetch;
	window.fetch = function ( url, options ) {
		if ( options && options.body instanceof FormData ) {
			const fieldName = options.body.get( 'field_name' );
			if ( fieldName && fieldName.endsWith( '_city' ) ) {
				// See the focusin handler below: a lone space means "list all".
				options.body.set(
					'query',
					String( options.body.get( 'query' ) ?? '' ).trim()
				);
				const territoryField = fieldName.replace(
					/_city$/,
					'_territory'
				);
				const dashedName = territoryField.replace( /_/g, '-' );
				const territories = [
					...document.querySelectorAll(
						`.pods-form-ui-row-name-${ dashedName } input[type="hidden"][name^="pods_field_${ territoryField }"]`
					),
				]
					.map( ( el ) => parseInt( el.value ) )
					.filter( Boolean );

				if ( territories.length ) {
					const sep = url.includes( '?' ) ? '&' : '?';
					url =
						url +
						sep +
						'territory_filter=' +
						territories.join( ',' );
				}
			}
		}
		return originalFetch.call( this, url, options );
	};
}

// react-select's AsyncSelect never calls loadOptions for an empty input, so the
// city dropdown would show "No options" on click. On focus, put a single space in
// the (empty) search input to make it fire; the fetch interceptor above trims it,
// so the server gets an empty query and returns the territory's cities.
document.addEventListener( 'focusin', ( event ) => {
	const input = event.target;
	if (
		! ( input instanceof HTMLInputElement ) ||
		input.value !== '' ||
		! input.closest( '[class*="pods-form-ui-row-name-"][class*="-city"]' )
	) {
		return;
	}
	const setter = Object.getOwnPropertyDescriptor(
		HTMLInputElement.prototype,
		'value'
	).set;
	setter.call( input, ' ' );
	input.dispatchEvent( new Event( 'input', { bubbles: true } ) );
} );
